// extracted by mini-css-extract-plugin
export default {"addCardContainer":"addCardButton_addCardContainer__acA7b","addIcon":"addCardButton_addIcon__kFF5x"};